import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class SecurityDeskController extends Controller {
  @service currentLocation;
}
